// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb-module__container__Mw3Ss","caret":"Breadcrumb-module__caret__Hz0Ck","future":"Breadcrumb-module__future__epXRd","active":"Breadcrumb-module__active__D8gIz"};